var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalmLeafsRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 98,
    viewBox: "0 0 93 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4223 42.6986L87.65 48.9334L84.4719 58.8512L75.2851 58.4899L82.7376 64.3766L78.4756 77.7655C40.2534 43.9561 94.8727 26.4057 94.8727 26.4057L90.0316 41.7778L79.4223 42.6986Z",
    fill: "#FFBA94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4688 -3.47136C74.1102 -5.17526 82.1198 2.91057 85.0985 9.43999L76.3392 9.90648L72.8904 3.98054L72.1644 10.1425L67.9896 10.3785L61.974 0.221862L60.7992 10.7444L58.411 10.8339L55.2416 5.39965L54.576 10.9526L42.775 11.6461C42.8449 11.769 44.8972 -1.64453 59.4688 -3.47136Z",
    fill: "#FFBA94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5447 27.566L59.36 41.196C56.5882 43.4063 53.6047 45.5473 50.551 47.6181L41.3472 39.4107L41.3977 52.6994C31.9684 56.793 22.2035 58.2736 13.7556 53.2419C13.7556 53.2419 17.0866 41.6266 25.7121 31.0353L32.3318 34.6657L29.6296 26.6966C32.7602 23.7064 36.3131 20.996 40.4276 18.8472L45.0889 29.7718L49.5683 15.6038C58.205 13.7069 68.5199 14.4846 80.9958 19.7007C80.9958 19.7007 74.6517 27.4489 65.3338 35.9244L57.5447 27.566Z",
    fill: "#FFBA94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmLeafsRight);
export default __webpack_public_path__ + "static/media/palmLeafsRight.b83df836f6d0a1a1fd600abcd3db7845.svg";
export { ForwardRef as ReactComponent };